import PropTypes from "prop-types";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

NameEntry.propTypes = {
  photo: PropTypes.string,
  label: PropTypes.string.isRequired,
  duplicateID: PropTypes.number.isRequired,
};

export default function NameEntry({ photo, label, duplicateID }) {
  const history = useHistory();
  const location = useLocation();

  const src = photo || "//dhdj1c2suf90g.cloudfront.net/images/nophoto.jpg";

  const handleClick = () => {
    history.push(`${location.pathname}/duplicate-profiles/${duplicateID}`);
  };

  return (
    <Wrapper onClick={handleClick}>
      <Photo src={src} />
      {label}
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  display: flex;
  align-items: center;
  padding: 6px 6px;
  font-size: 17px;
  font-weight: 400;
  border-radius: 10px;
  cursor: pointer;
  transition: background 200ms, transform 200ms;

  &:hover {
    background: rgba(110, 193, 228, 0.2);
  }

  &:active {
    transform: scale(0.98);
  }
`;

const Photo = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 8px;
  margin-right: 10px;
`;
